import apiClient from './apiClient';

// Entidades habilitadas para importación — deben coincidir exactamente con las keys en IMPORT_CONFIG del backend
export const ENTIDADES_IMPORTABLES = [
  'marcas',
  'familias',
  'tipos',
  'estados',
  'sucursales',
  'centroscosto',
  'ubicaciones',
  'motivosdetencion',
  'estados-reparacion',
  'tiposcontador',
  'tipos-rutina',
  'sistemas',
  'familias-repuesto',
  'marcas-repuesto',
  'unidades-medida',
  'tiposdocumentacion',
  'mecanicos',
  'tareasengrase',
  'modelos',
  'obras',
  'sectores-trabajo',
  'componentes',
  'subfamilias-repuesto',
  'tareas',
  'repuestos',
  'precios-repuestos',
  'empresas',
  'equipos',
  'catalogo-puntos-control',
  'puntos-control',
  'planes-mantenimiento',
  'rutinas-mantenimiento',
  'rutinas-tareas',
  'depositos',
  'tipos-combustible',
  'categorias-logistica',
  'categorias-cargas',
  'centros-logisticos',
  'transportistas',
  'lugares-despacho',
  'cisternas-despacho',
  'clientes-alquiler',
];

/**
 * Descarga la plantilla Excel para una entidad.
 * Dispara la descarga del archivo en el navegador.
 */
export async function descargarPlantilla(entidad) {
  const response = await apiClient.get(`importar/${entidad}/plantilla/`, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const contentDisposition = response.headers['content-disposition'] || '';
  const match = contentDisposition.match(/filename="?([^"]+)"?/);
  link.setAttribute('download', match ? match[1] : `plantilla_${entidad}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

// Qué hace la importación con los registros que ya están cargados.
export const MODO_AGREGAR = 'agregar';
export const MODO_ACTUALIZAR = 'actualizar';

/**
 * Sube un archivo Excel al servidor para importar la entidad indicada.
 * `modo` decide qué pasa con las filas que coinciden con un registro ya cargado:
 * 'agregar' las deja intactas, 'actualizar' les aplica los datos de la planilla.
 * Retorna: { modo, importados, actualizados, ya_existian, errores: [{fila, columna, valor, mensaje}] }
 */
// Una importación grande se mide en minutos, no en segundos: el timeout global
// de 30 s de apiClient —correcto para el resto de la app— cortaba la espera del
// navegador mientras el servidor seguía trabajando, y el usuario recibía un
// "no se pudo procesar el archivo" sobre una planilla que estaba perfecta.
// Solo se levanta para esta llamada.
export const TIMEOUT_IMPORTACION_MS = 10 * 60 * 1000;

export async function importar(entidad, archivo, modo = MODO_AGREGAR) {
  const formData = new FormData();
  formData.append('archivo', archivo);
  formData.append('modo', modo);
  const response = await apiClient.post(`importar/${entidad}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: TIMEOUT_IMPORTACION_MS,
  });
  return response.data;
}
